import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-policy',
  templateUrl: './dialog-policy.component.html',
  styleUrls: ['./dialog-policy.component.css']
})
export class DialogPolicyComponent implements OnInit {
  pdfSrc: string;
  isChecked = false;

  constructor(
    public dialogRef: MatDialogRef<DialogPolicyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pdfSrc = data.pdfSrc;
  }

  ngOnInit(): void {
  }

  onAccept(): void {
    this.dialogRef.close(true);
  }

}
